import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IVideoArtistResponse } from './types';

export const useGetVideoArtists = (id: string, enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IVideoArtistResponse[], DefaultError>({
    queryKey: ['video-artists', id],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Video/GetArtistList`,
        params: { videoId: id },
      });

      return responseHandler(response, {
        groupName: `useGetVideoArtists - ${id}`,
        notFoundPath: '/video',
      });
    },
    enabled: enabled,
  });
};
